import React from "react"
import types from "prop-types"
import * as DatesValidations from "./DatesValidations"
import EndDateQuestionUuid from "./EndDateQuestionUuid"
import StartDateQuestionUuid from "./StartDateQuestionUuid"

const Dates = ({ sectionIndex, questionIndex }) => (
  <>
    <div className="mb-1 font-medium">
      Dates
    </div>
    <p className="text-sm mb-2">Select the dates that the difference will be measured between.</p>
    <div className="mb-2">
      <StartDateQuestionUuid sectionIndex={sectionIndex} questionIndex={questionIndex} />
    </div>
    <EndDateQuestionUuid sectionIndex={sectionIndex} questionIndex={questionIndex} />
    <DatesValidations.NoBlankDatesValidation
      questionIndex={questionIndex}
      sectionIndex={sectionIndex}
    />
    <DatesValidations.DatesAreNotBothCurrentDateValidation
      questionIndex={questionIndex}
      sectionIndex={sectionIndex}
    />
    <DatesValidations.DatesResolveToDateQuestionsValidation
      questionIndex={questionIndex}
      sectionIndex={sectionIndex}
    />
  </>
)

Dates.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default Dates
